import { Button, Grid, TextField } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import parse from 'html-react-parser'
import React, { FC } from 'react'

import {
  fieldError,
  fieldErrorText,
  nextDisabled,
  onNext,
  PardotFormProps,
} from '../../utils/form/useForm'
import SectionWrapper from './SectionWrapper'

interface StepOneProps {
  form: PardotFormProps
  headline: string
  body?: string
  firstNameLabel?: string
  lastNameLabel?: string
  handleNext: () => void
  currentSlide: number
}

const useStyles = makeStyles((theme) =>
  createStyles({
    stepOneContainer: {
      textAlign: 'left',
      height: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'flexStart',
        height: 'auto',
      },
    },
    calloutText: {
      margin: 'auto 0 auto',
      maxWidth: '24ch',
      textAlign: 'left',
      fontSize: '4rem',
      fontWeight: 300,
      lineHeight: 1.15,
      letterSpacing: '-1.5px',
      color: '#FFFFFF',

      '& a': {
        color: 'inherit',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '3.6rem',
        margin: '0 auto 48px auto',
        textAlign: 'center',
      },
    },

    largeTopMargin: {
      marginTop: 50,
    },
    buttonContainer: {
      marginTop: '75px',
      marginBottom: '25px',
    },
    button: {
      backgroundColor: '#E9B265',
      fontWeight: 'bold',
      color: 'white',
      '&::placeholder': {
        color: '#E9B265',
      },
    },
  }),
)

const StepOne: FC<StepOneProps> = ({
  form,
  form: { values, handleChange },
  headline,
  body,
  firstNameLabel,
  lastNameLabel,
  handleNext,
  currentSlide,
}) => {
  const classes = useStyles()

  const stepOneFields = ['firstName', 'lastName'] as const

  return (
    <Grid className={classes.stepOneContainer} container>
      <Grid
        container
        direction="column"
        item
        justifyContent="center"
        md={3}
        xs={12}
      >
        {body ? (
          <Grid item>
            <div className={classes.calloutText}>{parse(body)}</div>
          </Grid>
        ) : null}
      </Grid>
      <Grid item md={6} xs={12}>
        <SectionWrapper currentSlide={currentSlide} headline={headline}>
          <TextField
            className={classes.largeTopMargin}
            disabled={currentSlide !== 0}
            error={fieldError(form, 'firstName')}
            helperText={fieldErrorText(form, 'firstName')}
            id="firstName"
            inputProps={{
              sx: {
                '&::placeholder': {
                  color: 'red',
                },
              },
            }}
            label={firstNameLabel}
            name="firstName"
            onChange={handleChange}
            value={values.firstName}
            variant="filled"
          />
          <TextField
            disabled={currentSlide !== 0}
            error={fieldError(form, 'lastName')}
            helperText={fieldErrorText(form, 'lastName')}
            id="lastName"
            label={lastNameLabel}
            name="lastName"
            onChange={handleChange}
            value={values.lastName}
            variant="filled"
          />
          <Grid
            className={classes.buttonContainer}
            container
            item
            justifyContent="center"
          >
            <Button
              className={classes.button}
              disableElevation
              disabled={currentSlide !== 0 || nextDisabled(form, stepOneFields)}
              onClick={onNext(form, stepOneFields, handleNext)}
              variant="contained"
            >
              Next {'>'}
            </Button>
          </Grid>
        </SectionWrapper>
      </Grid>
      <Grid item md={3} xs={12} />
    </Grid>
  )
}

export default StepOne
